<div class="position-relative m-0">
  <input
    #postcodeInput
    #instance="ngbTypeahead"
    class="form-control"
    id="postcodeInput"
    (keyup)="geolocatePostcode(postcodeInput.value)"
    name="postcodeInput"
    [ngbTypeahead]="getPostcodes"
    [(ngModel)]=postcode.name
    placeholder="Postcode"
    (selectItem)="selectPostcode($event)"
    type="text">
</div>
